// Les @font-face d'abord : le navigateur doit connaître les polices avant de
// rencontrer la première règle qui les utilise.
import './styles/polices.css'
import './styles/reset.css'
import './styles/jetons.css'
import './styles/app.css'

import { monterAnimer } from './ecrans/animer'
import { monterCodeSaison } from './ecrans/code-saison'
import { monterLampe } from './ecrans/lampe'
import { monterPatrouille } from './ecrans/patrouille'
import { monterSaison } from './ecrans/saison'
import { monterSignaler } from './ecrans/signaler'

import { sessionOuverte } from './noyau/session'
import { demarrerSynchronisation } from './noyau/sync'
import { surEvenement } from './noyau/bus'
import { viderCacheZonage } from './noyau/zonage'

import { demarrerBandeauFile } from './ui/bandeau-file'
import { demarrerBarreEtat } from './ui/barre-etat'
import { rendreOnglets } from './ui/barre-onglets'
import { requis, vider } from './ui/dom'
import { surRoute, type Onglet } from './ui/routeur'
import { initTheme } from './ui/theme'

type Monteur = (hote: HTMLElement) => () => void

const ECRANS: Record<Exclude<Onglet, 'lampe'>, Monteur> = {
  patrouille: monterPatrouille,
  signaler: monterSignaler,
  saison: monterSaison,
  animer: monterAnimer,
}

let demonterEcran: (() => void) | null = null
let demonterLampe: (() => void) | null = null

function brancherRoutes(): void {
  requis('onglets').hidden = false
  requis('bandeau-file').hidden = false

  surRoute((onglet) => {
    rendreOnglets()

    if (onglet === 'lampe') {
      // La lampe est une surcouche : l'écran précédent reste monté dessous,
      // on ne le démonte pas pour rien.
      if (!demonterLampe) demonterLampe = monterLampe()
      return
    }

    if (demonterLampe) {
      demonterLampe()
      demonterLampe = null
    }

    demonterEcran?.()
    const hote = requis('ecran')
    vider(hote)
    demonterEcran = ECRANS[onglet](hote)
  })
}

async function demarrer(): Promise<void> {
  await initTheme()
  demarrerBarreEtat()

  surEvenement('zonage-change', viderCacheZonage)

  if (!(await sessionOuverte())) {
    // Premier lancement : ni onglets ni bandeau tant que la saison n'est pas ouverte.
    requis('onglets').hidden = true
    requis('bandeau-file').hidden = true
    monterCodeSaison(requis('ecran'), () => {
      vider(requis('ecran'))
      demarrerBandeauFile()
      demarrerSynchronisation()
      brancherRoutes()
    })
    return
  }

  demarrerBandeauFile()
  demarrerSynchronisation()
  brancherRoutes()
}

void demarrer().catch((e) => {
  // Dernier filet : mieux vaut un message franc qu'un écran noir sur la plage.
  console.error('[kwata] démarrage impossible', e)
  requis('ecran').textContent =
    "L'application n'a pas pu démarrer sur ce téléphone. Le stockage local est peut-être bloqué (navigation privée)."
})
